import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  singleQuiz: {},
}

export const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    getAllQuizes: (state, action) => {
      state.data = action.payload;
    },
    getSingleQuiz: (state, action) => {
      state.singleQuiz = action.payload;
    },
    resetQuiz: (state) => {
      state.data = [];
      state.singleQuiz = {}
    }
  },
})

// Action creators are generated for each case reducer function
export const { getAllQuizes, getSingleQuiz, resetQuiz } = quizSlice.actions

export default quizSlice.reducer;